export const APPLOADER_START = 'REDUX_APPLOADER_START';
export const APPLOADER_END = 'REDUX_APPLOADER_END';

export const actionStartAppLoader = (dispatch) => {
    dispatch({ type: APPLOADER_START });
};

export const actionEndAppLoader = (dispatch) => {
    dispatch({ type: APPLOADER_END });
};